import { useTranslator } from '@translator-app/react';
import { useRouter } from 'next/router';
import React from 'react';

import { useApplicationState } from '../../contexts/application-state-context';
import { OrderStatusEnumType } from '../../generated/graphql';
import { buildOrderPath } from '../../utils/order-path';

export const OrderHint: React.FC = () => {
  let { order } = useApplicationState();
  let router = useRouter();
  let { translate } = useTranslator();

  if (order?.status !== OrderStatusEnumType.Created) {
    return null;
  } else {
    return (
      <div className="mx-auto max-w-7xl px-6 py-4">
        <div>
          <a
            href={buildOrderPath({
              locale: router.locale,
              shortToken: order.shortToken,
            })}
            className="block w-full px-2 py-2 rounded border border-brand-600 bg-brand-600 text-white mb-8 text-center font-medium"
          >
            {translate('order.openOrderLink')}
          </a>
        </div>
      </div>
    );
  }
};
